import {Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {CredentialsService} from "@app/core/authentication/credentials.service";
import {UserDeleteDialogComponent} from "../partials/user-delete-dialog/user-delete-dialog.component";
import {Participant} from "@shared/models/Participant";
import {BackendService} from "@core/backendService/backend.service";
import {PointService} from "@pages/user/service/point/point.service";
import {Point} from "@core/models/Point";
import {UserEmailChangeDialogComponent} from '../partials/user-emailchange-dialog/user-change-dialog.component';
import {Observable} from "rxjs";
import {filter, map, shareReplay, switchMap} from "rxjs/operators";
import {Credentials} from "@core/authentication/credentials.service";


@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss'],
})
export class UserDetailComponent{
  constructor(
      private readonly credentialsService:CredentialsService,
      private readonly backendService:BackendService,
      private readonly pointService:PointService,
      private readonly dialog: MatDialog
  ) {}

  public participantID$: Observable<number> = this.credentialsService.change$.pipe(
      map((credentials:Credentials)=>credentials?.participant_id),
      shareReplay(1)
  )
  public participant$: Observable<Participant> = this.participantID$.pipe(
      filter((id:number)=>!!id),
      switchMap((id:number)=>this.backendService.get_participant_detail(id))
  )
  public point$: Observable<Point> = this.pointService.points$

  openDeleteDialogModal(){
    this.dialog.open(UserDeleteDialogComponent, {
      width: '33%',
      minWidth: '300px',
    });
  }
  openNewMailDialogModal(){
    this.dialog.open(UserEmailChangeDialogComponent, {
      width: '50%',
      minWidth: '300px'
    });
  }
}
